<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
      <div v-if="canIEditVehicle(detailedInfo)" class="pull-right">
        <b-button variant="outline-primary" @click="section = 'edit'" v-if="section === ''"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"            :active="section === ''"           >Preview</b-nav-item>
        <b-nav-item @click="section = 'assign_vehicle'" :active="section === 'assign_vehicle'">Assign Vehicle</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import vehicleGroupMixin from '@/mixins/vehicle_group';
// import { isEmpty } from 'lodash';

export default {
  name: 'vehicle_detail',
  mixins: [vehicleGroupMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    const { vehicleGroupId } = this.$route.params;
    this.$store.commit('vehicle_group/SET_DETAIL_ID', vehicleGroupId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'vehicle_group', name: 'Vehicle Group' },
      { to: vehicleGroupId, name: 'Detail' },
    ]);
    this.$store.dispatch('vehicle_group/LOAD_DETAIL_DATA');
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['vehicle_group/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.name;
    },
  },
  watch: {
    section(newSection) {
      const { vehicleGroupId } = this.$route.params;
      this.$router.push(`/vehicle_group/${vehicleGroupId}/${newSection}`);
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/vehicle_group/Detail.vue